import React, { useEffect, useRef, useState } from 'react';

import Moengage from '@moengage/web-sdk';

import './softask.scss';

import { showComponentOnSelectedRoute } from 'components/app/helpers';
import { RenderByExchange } from 'components/render/RenderByExchangeType';
import routes from 'constants/routes';
import MoengageLib from 'helpers/moengage';
import { addLogsToSentry } from 'helpers/sentry';
import i18n from 'i18n/config';
import { userSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import DeltaIndiaLogoMobile from 'styles/assets/icons/DeltaIndiaLogoMobile';
import DeltaLogoMobile from 'styles/assets/icons/DeltaLogoMobile';

const textMoengageInfo = i18n.t('common:moengaage.info');

const textMoengageInfo2 = i18n.t('common:moengaage.info2');

const textMoengageAllow = i18n.t('common:moengaage.allow');

const textMoengageDontAllow = i18n.t('common:moengaage.dontAllow');

/**
 * @description Popup to ask user for web push notifications permission
 * @see https://developers.moengage.com/hc/en-us/articles/360061219351-Configure-Self-Handled-Opt-In
 */
const SoftAsk = () => {
  const [timer, setTimer] = useState(0);

  const blockBtnRef = useRef<HTMLButtonElement | null>(null);

  const location = useAppSelector(state => state.router.location);
  const user = useAppSelector(userSelector);

  useEffect(() => {
    const listener = (e: any) => {
      if (e && e.detail === 'soft_ask_shown') {
        setTimer(10);

        // auto clicking the notification deny button
        setTimeout(() => {
          if (blockBtnRef.current) blockBtnRef.current.click();
        }, 10000);
      }
    };
    window.addEventListener('MOE_OPT_IN', listener);
    try {
      if (
        MoengageLib.showOptIn() &&
        showComponentOnSelectedRoute(['/:productType/markets', routes.homepage.default])(
          location
        )
      ) {
        Moengage.call_web_push({
          soft_ask: true,
          main_class: 'moe-main-class',
          allow_class: 'moe-allow-class',
          block_class: 'moe-block-class',
        });
      }
    } catch (err) {
      addLogsToSentry(user, err);
    }

    return () => {
      window.removeEventListener('MOE_OPT_IN', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (timer > 0)
      setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
  }, [timer]);

  return (
    (<div
      className="moe-main-class"
      style={{ display: 'none' }}
      data-palette="SoftAsk">
      <div
        className="moe-chrome-style-notification moe-chrome-style-notification-safari"
        data-rapid_height={50}
      >
        <div className="moe-safari-notification-inner-wrapper">
          <div className="moe-notification-image-wrapper-safari">
            <RenderByExchange
              global={<DeltaLogoMobile height={50} width={50} />}
              indian={<DeltaIndiaLogoMobile height={50} width={50} />}
            />
          </div>
          <div className="moe-text-wrapper-safari">
            <span className="moe-notification-title-safari">{textMoengageInfo}</span>
            <p className="moe-notification-message-safari">{textMoengageInfo2}</p>
          </div>
          <div style={{ clear: 'both' }}>
            <div className="moe-button-wrapper">
              <button
                className="moe-chrome-style-notification-btn moe-btn-close moe-block-class"
                data-testid="moengage-dont-allow"
                type="button"
                ref={blockBtnRef}
                onClick={e => {
                  /**
                   * We programmatically auto-click this button using ref, but that auto-click counts as a user interaction and
                   * causes google one-tap login popup to also close with it. So stopping this click from propagating is necessary.
                   */
                  e.stopPropagation();
                }}
              >
                {`${textMoengageDontAllow} (${timer})`}
              </button>
              <button
                type="button"
                className="moe-chrome-style-notification-btn moe-btn-allow moe-allow-class"
                data-testid="moengage-allow"
              >
                {textMoengageAllow}
              </button>
            </div>
            <div style={{ clear: 'both' }} />
          </div>
        </div>
      </div>
    </div>)
  );
};
export default SoftAsk;
